import React, { useState, useEffect, useContext } from "react";
import FadeIn from "react-fade-in";
import { FaChevronRight } from "react-icons/fa";

import ExerciseCard from "../../../../InterstellrComponents/ExerciseCard.jsx";
import ExerciseVideoPopup from "../../../sub-components/employeeSub/ExerciseVideoPopup.jsx";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { GET_EXERCISES, GET_PAGE_TITLE } from "../../../../Routes.js";
import { generateURLOptions } from "../../../../URLOptions.js";
import { UserContext } from "../../../../storage/contexts/UserContext.js";

const Exercise = () => {
  const { profile } = useContext(UserContext);

  const [visible, setVisible] = useState(true);
  const [exercises, setExercises] = useState([]);

  const [pageTitle, setPageTitle] = useState("");

  const [selectedVideo, setSelectedVideo] = useState({});
  const [isVideoPopupOpen, setIsVideoPopupOpen] = useState(false);

  const navigate = useNavigate();

  const handleVideoPopupOnClick = (item) => {
    setIsVideoPopupOpen(true);
    setSelectedVideo(item);
  };

  const handlePopupOnCloseClick = () => {
    setIsVideoPopupOpen(false);
  };

  useEffect(() => {
    getPageTitle();
    getExercises();
  }, []);

  // Define a custom comparator function
  const compareItems = (a, b) => {
    if (a.position < b.position) {
      return -1;
    }
    if (a.position > b.position) {
      return 1;
    }
    return 0;
  };

  const getPageTitle = async () => {
    await axios
      .get(GET_PAGE_TITLE + "exercise", {
        headers: generateURLOptions(),
      })
      .then(async (response) => {
        console.log(response);
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }

        setPageTitle(response.data?.data?.heading ?? "");
      })
      .catch((error) => {
        console.log("Get Priority Notifications Error: ", error);
        return alert(error);
      });
  };

  const getExercises = async () => {
    await axios
      .get(GET_EXERCISES, {
        headers: generateURLOptions(),
      })
      .then(async (response) => {
        console.log(response);
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }

        var data = response.data.data;

        data?.data?.forEach((obj) => {
          obj.exercises?.sort(compareItems);
        });

        setExercises(data);
      })
      .catch((error) => {
        console.log("Get Exercises Data Error: ", error);
        return alert(error);
      });
  };

  const viewCategory = (data) => {
    setVisible(false);
    setTimeout(() => {
      navigate("/wellness/exercises/category", {
        state: {
          categoryId: data?._id,
        },
      });
    }, 350);
  };

  return (
    <>
      {isVideoPopupOpen && (
        <ExerciseVideoPopup
          key={selectedVideo._id}
          item={selectedVideo}
          isOpen={isVideoPopupOpen}
          closeModal={handlePopupOnCloseClick}
        />
      )}
      <div
        className="w-screen min-h-screen"
        style={{
          background: `linear-gradient(45deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.8) 45%, ${
            profile?.company_id
              ? profile?.company_id?.company_primary_color
              : "rgba(81, 83, 245, 1)"
          } 150%)`,
        }}
      >
        <FadeIn delay={200} visible={visible}>
          <div className="container mx-auto flex flex-col justify-center items-center h-full w-full pb-24">
            <div className="mt-12 w-full px-6 md:px-0">
              <h4 className="text-xl md:text-2xl font-semibold">
                {pageTitle ? pageTitle : "Eat well 🍎"}
              </h4>

              {exercises?.map((exercise) => (
                <div key={exercise?._id} className="flex flex-col mt-4 pb-4">
                  <div className="flex flex-row justify-center items-center">
                    <h4 className="text-lg font-medium text-black">
                      {exercise?.name ?? ""}
                    </h4>

                    <div style={{ flex: 1 }} />

                    <button
                      className="text-black font-medium text-base"
                      onClick={() => viewCategory(exercise)}
                    >
                      View All {exercise?.name ?? ""} Items
                    </button>
                    <FaChevronRight fontSize={14} className="ml-1" />
                  </div>
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2 md:gap-4 mt-6">
                    {exercise?.exercises?.map((subItem, index) =>
                      index < 5 ? (
                        <ExerciseCard
                          key={subItem._id}
                          exercise={subItem}
                          onClick={handleVideoPopupOnClick}
                        />
                      ) : null
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </FadeIn>
      </div>
    </>
  );
};

export default Exercise;
